var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: { pageRoot: true } }, [
    _c("div", { staticClass: "heading" }, [_vm._v("Power Status")]),
    _vm._v(" "),
    _c("div", { staticClass: "bodySection" }, [
      _c("p", { staticStyle: { "font-weight": "bold" } }, [
        _vm._v("\n\t\t\t" + _vm._s(_vm.ipmiPowerStatus) + "\n\t\t"),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "refreshButton",
          attrs: { disabled: _vm.ipmiPowerLoading },
          on: { click: _vm.GetIpmiPowerStatus },
        },
        [
          _c("vsvg", {
            staticClass: "refreshIcon",
            attrs: { sprite: "refresh" },
          }),
          _vm._v(" Refresh\n\t\t"),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "heading" }, [
      _vm._v("Change Your Machine's Power State"),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "bodySection" },
      [
        _vm._l(_vm.ipmiPowerOptions, function (ps) {
          return _c("div", { key: ps.name }, [
            _c("label", { staticClass: "radioLabel" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedPowerState,
                    expression: "selectedPowerState",
                  },
                ],
                attrs: { type: "radio" },
                domProps: {
                  value: ps.name,
                  checked: _vm._q(_vm.selectedPowerState, ps.name),
                },
                on: {
                  change: function ($event) {
                    _vm.selectedPowerState = ps.name
                  },
                },
              }),
              _vm._v(" " + _vm._s(ps.description) + "\n\t\t\t"),
            ]),
          ])
        }),
        _vm._v(" "),
        _c("p"),
        _vm._v(" "),
        _c("slide-button", {
          key: "slideBtn_powerstate_" + _vm.powerStateSlideBtnCounter,
          attrs: {
            "auto-width": false,
            circle: true,
            disabled: _vm.ipmiPowerLoading,
            noanimate: true,
            width: 300,
            height: 60,
            text: "slide to set",
            "success-text": "setting",
            requireReleaseToComplete: true,
          },
          on: {
            completed: function ($event) {
              return _vm.onPowerStateCommanded()
            },
          },
        }),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "heading" }, [
      _vm._v("IPMI (Remote KVM) Firewall Status"),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "bodySection" },
      [
        _c("div", {
          directives: [
            {
              name: "dompurify-html",
              rawName: "v-dompurify-html",
              value: _vm.ipmiConnectionInfo.html,
              expression: "ipmiConnectionInfo.html",
            },
          ],
          staticClass: "ipmiConnectionInfoMessage",
        }),
        _vm._v(" "),
        _vm.ipmiConnectionInfo.details
          ? [
              _c("table", { staticClass: "ipmiDetails" }, [
                _c(
                  "tbody",
                  _vm._l(_vm.ipmiConnectionInfo.details, function (d) {
                    return _c("tr", { key: d.key }, [
                      _c("td", [_vm._v(_vm._s(d.key))]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "copy",
                          on: {
                            click: function ($event) {
                              return _vm.copy(d.value)
                            },
                          },
                        },
                        [_vm._v(_vm._s(d.value))]
                      ),
                    ])
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _vm.ipmiConnectionInfo.firstsetup
                ? _c("p", [
                    _c("i", [
                      _vm._v(
                        'The source IP address in the status description above has been known to be incorrect upon first setup.  If you click "Refresh" below, it should be fixed.'
                      ),
                    ]),
                  ])
                : _c("p"),
            ]
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "refreshButton",
            attrs: { disabled: _vm.ipmiConnectionInfo.loading },
            on: { click: _vm.GetIpmiConnectionInformation },
          },
          [
            _c("vsvg", {
              staticClass: "refreshIcon",
              attrs: { sprite: "refresh" },
            }),
            _vm._v(" Refresh\n\t\t"),
          ],
          1
        ),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "heading" }, [_vm._v("Setup IPMI Firewall")]),
    _vm._v(" "),
    _c("div", { staticClass: "bodySection" }, [
      _c("div", { staticClass: "yourIpSection" }, [
        _c(
          "button",
          {
            staticClass: "loadIp",
            attrs: {
              title: "Puts your public IP into the box",
              disabled: _vm.yourIpLoading,
            },
            on: { click: _vm.LoadPublicIP },
          },
          [
            _c("vsvg", {
              staticClass: "refreshIcon",
              attrs: { sprite: "refresh" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("label", [
          _c("b", [_vm._v("Your IP Address")]),
          _c("br"),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.yourIp,
                expression: "yourIp",
              },
            ],
            staticClass: "yourIp",
            attrs: { type: "text" },
            domProps: { value: _vm.yourIp },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.yourIp = $event.target.value
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "The above IP address will be granted temporary access to your InterServer workstation's IPMI (remote KVM) interface."
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { "margin-top": "1em" } }),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "margin-top": "1em" } },
        [
          _c("slide-button", {
            key: "slideBtn_powerstate_" + _vm.ipmiConnectionSlideBtnCounter,
            attrs: {
              "auto-width": false,
              circle: true,
              disabled: _vm.ipmiConnectionInfo.loading,
              noanimate: true,
              width: 300,
              height: 60,
              text: "setup IPMI",
              "success-text": "setting",
              requireReleaseToComplete: true,
            },
            on: {
              completed: function ($event) {
                return _vm.onIpmiConnectionCommanded()
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }